import { useEffect } from "react";

import { Paths } from "configs";
import { usePermission, usePushRoute } from "hooks";
import { PageContainer } from "pages/Components";
import { useLocation } from "react-router-dom";

const IndexPage = () => {
  const { pushRoute } = usePushRoute();
  const location = useLocation();
  const { havePermission, canAccess } = usePermission();
  // useEffect check route change

  useEffect(() => {
    if (havePermission) {
      pushRoute(
        {},
        canAccess("TimeAttendanceDataList")
          ? Paths.TimeAttendance
          : Paths.Country
      );
    } else {
      pushRoute({}, Paths.Country);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, havePermission]);

  return (
    <PageContainer seoTitle="Homepage" title="">
      <div />
    </PageContainer>
  );
};

export default IndexPage;
